/**
 * 商务特殊费用行可见性：只由商务特殊自身权限决定（查看 所有/同组/个人），
 * 与普通应收/应付费用的全部/同组/个人闸门无关。
 * 同组 = 部门团队（含子部门）包含费用的创建者或录入者；本人创建/录入的行在 viewDept 下同样可见（团队天然含本人）。
 */
export function isBusinessSpecialChargeVisible(charge, ctx) {
  if (!charge || !ctx) {
    return false
  }
  if (ctx.viewAll) {
    return true
  }
  const currentUserId = ctx.currentUserId
  const own = charge.createdBy === 0 || charge.createdBy === currentUserId || charge.inputBy === currentUserId
  if (ctx.viewDept) {
    if (own) {
      return true
    }
    const team = ctx.departmentTeamUser || []
    for (const userId of team) {
      if (userId === charge.inputBy || userId === charge.createdBy) {
        return true
      }
    }
  }
  if (ctx.viewUser && own) {
    return true
  }
  return false
}
